export const isOpenForIntake = (service) => !service || service.isIntakeOpen !== false;

export const onlyOpenForIntake = (services = []) => services.filter(isOpenForIntake);

export const closedServiceKeys = (services = []) =>
    services.filter((service) => !isOpenForIntake(service)).map((service) => service.key);

export const canBeOffered = (service, { alreadyOnRequest = false } = {}) =>
    alreadyOnRequest || isOpenForIntake(service);

export const withoutClosedKeys = (serviceKeys = [], services = []) => {
    const closedKeys = closedServiceKeys(services);

    return serviceKeys.filter((serviceKey) => !closedKeys.includes(serviceKey));
};

export const withoutClosedServices = (services = [], closedKeys = []) =>
    services.filter((service) => !closedKeys.includes(service.key));

export const withoutClosedPackageServices = (packageServices = [], closedKeys = []) =>
    packageServices.filter((packageService) => !closedKeys.includes(packageService.serviceKey));

export const packageForShowcase = (listedPackage, closedKeys = []) => {
    if (!listedPackage) return listedPackage;

    return {
        ...listedPackage,
        packageServices: withoutClosedPackageServices(listedPackage.packageServices, closedKeys)
    };
};
